import React, { Component } from 'react';
import { Form, Input, Modal } from 'antd';

class Demo extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.names = values.names ? values.names.split('\n') : '';
        this.props.handleAdd(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        visible
        title="新增地址"
        onCancel={this.props.onCancel}
        width={500}
        onOk={this.handleSubmit}
      >
        <Form>
          <Form.Item>
            {getFieldDecorator(
              'names',
              {},
            )(
              <Input.TextArea
                placeholder={`请输入具体地址，每行一个地址，如下所示：
远方1幢1单元201
远方1幢1单元201
远方1幢1单元201
远方1幢1单元201
远方1幢1单元201`}
                rows={8}
                maxLength={1000}
              />,
            )}
            <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Demo);



// WEBPACK FOOTER //
// ./src/components/incubator/address/ModalAdd.js